<h1 class="skymiles-landing-page-earns__header">{{ content.title }}</h1>
<div
  [skeletonMetaData]="{
    loaded: content.banner.loaded,
    error: content.banner.error,
    disabled: content.banner.disabled
  }"
  class="skymiles-landing-page-earns__container--gap"
  (action)="redirect($event)"
  auraSkeletonLoader
>
  @if (!content.banner.disabled) {
    <idp-fast-action-banner-page
      (offerAction)="redirect(content.banner.offer.action?.link?.url || '')"
      [config]="content.banner.offerConfig"
      [content]="content.banner.offer"
      [displaySecondaryHeader]="displaySecondaryHeader"
      [styles]="content.banner.offerStyles"
      [title]="content.title"
    ></idp-fast-action-banner-page>
  }
</div>
<idp-offers
  [content]="content.offers"
  [skeletonMetaData]="{
    loaded: content.offers.loaded,
    error: content.offers.error,
    disabled: content.offers.disabled
  }"
  class="skymiles-landing-page-earns__container--gap"
  (action)="redirect($event)"
  (clickAnalyticsEvent)="handleOffersClick($event)"
  auraSkeletonLoader
></idp-offers>
@if (content.partners) {
  <idp-partners
    [showLinked]="true"
    class="skymiles-landing-page-earns__container--gap"
    (clickAnalyticsEvent)="handlePartnersClick($event)"
  ></idp-partners>
}
@if (!content.relatedLinks.disabled) {
  <idp-related-links
    [content]="content.relatedLinks"
    (analyticsEvent)="onAnalyticsEvent($event)"
    class="skymiles-landing-page-earns__container--gap"
  ></idp-related-links>
}
